// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

/**
 * Generate SasIPRange format string. For example:
 *
 * "8.8.8.8" or "1.1.1.1-255.255.255.255"
 *
 * @param ipRange -
 */
export function ipRangeToString(ipRange) {
  return ipRange.end ? "".concat(ipRange.start, "-").concat(ipRange.end) : ipRange.start;
}